import React from 'react';

export const SelektIkon = () => (
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="13" cy="13" r="13" transform="rotate(90 13 13)" fill="#CE0060" />
		<path d="M17.3362 11.8073L12.9589 16.1846L8.58153 11.8073" stroke="white" strokeWidth="2" />
	</svg>
);
